import { useQuery } from 'react-apollo';
import { Money } from 'shared/types/common';
import { useAuthenticationStatus } from 'shared/hooks/user';
import { MainAccountsQuery } from '../queries/MainAccountsQuery/__generated__/MainAccountsQuery';
import * as query from '../queries/MainAccountsQuery/query.gql';

const zeroBalances: Record<string, Money> = {
  USD: { value: 0, currency: 'USD' },
  RUB: { value: 0, currency: 'RUB' },
};

export const useBalances = () => {
  const isAuthenticated = useAuthenticationStatus();

  const { data, loading, error } = useQuery<MainAccountsQuery>(query, {
    skip: !isAuthenticated,
  });

  return {
    loading: loading || !isAuthenticated,
    error,
    balances: (data?.billing.mainAccounts || []).reduce(
      (result, { balance }) => ({
        ...result,
        [balance.currency]: balance,
      }),
      zeroBalances
    ),
  };
};

export const useBalance = (currency: string) => {
  const isAuthenticated = useAuthenticationStatus();

  const { data, loading, error } = useQuery<MainAccountsQuery>(query, {
    skip: !isAuthenticated,
  });

  const result = data?.billing.mainAccounts.find(({ balance }) => balance.currency === currency);

  return {
    loading: loading || !isAuthenticated,
    error,
    balance: result?.balance || { value: 0, currency },
  };
};
